import { useState, useContext } from "react";
import styles from "./Navbar.module.scss";
import modulars from "../styles/modulars.module.scss";
import UserModal from "./Modals/UserModal";
import { AppContext } from "../AppContext";
import UserImage from "./UserImage";
import { useNavigate } from "react-router-dom";

const NavButton = ({ url = "", children }) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => {
        navigate(url);
      }}
      className={styles.nav_button}
    >
      <span>{children}</span>
    </button>
  );
};

function Navbar() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user } = useContext(AppContext);

  const handleClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const getUserFirstLastName = () => {
    return user ? user.first_name + " " + user.last_name : "Not logged in";
  };

  return (
    <nav className={styles.nav}>
      <div className={styles.nav_buttons}>
        <NavButton url="/">Home</NavButton>
        <NavButton url="/clients">Clienti</NavButton>
        {process.env.NODE_ENV === "development" && (
          <>
            {user && user.is_superuser ? (
              <NavButton url="/workers">Lavoratori</NavButton>
            ) : null}
            <NavButton url="/test">Test</NavButton>
          </>
        )}
      </div>
      <div className={styles.nav_div + " " + modulars.flex_justify_end}>
        <div style={{ fontWeight: 600 }}>{getUserFirstLastName()}</div>
        <button onClick={handleClick} className={modulars.tr_btn}>
          <UserImage />
        </button>
        <UserModal
          text={getUserFirstLastName()}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </div>
    </nav>
  );
}

export default Navbar;
